

    import ResearchItem from 'components/resources/ResearchItem.vue';
    import {ref, defineComponent} from 'vue';
    import {MetadataResearchArticle} from 'src/contracts/getMetadataResearchResponse';

    export default defineComponent ({
      name: 'EditsSectionContainer',
      components: {
        ResearchItem,
      },
      props: {
        researchSectionDataModel: {
          required: true,
        }
      },
      setup() {
        return {
          othersExpanded: ref(false)
        }
      },
      methods: {
        showArticles(articles: MetadataResearchArticle[], bestMatch: boolean) {
          return articles?.filter(article => article.is_best_match === bestMatch);
        }
      }
    })
